import React, { useState, useEffect } from 'react'
import {
  Panel,
  Row,
  Col,
  ControlLabel,
  Input,
  Form,
  SelectPicker,
  DatePicker,
  RadioGroup,
  Radio,
  Grid,
} from 'rsuite'

import { isRequired, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import moment from 'moment'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../constants/date'

export default function projectApprovalSummaryForStaffForm({
  schema: _schema,
  mockSchema: _mockSchema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  handelPreview,
  isDisabled,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)

  return (
    <>
      <Form>
        <Grid fluid>
          <Row>
            <Col
              lg={3}
              md={3}
              sm={8}
              xs={8}
              style={{ marginTop: '5px', padding: '8px', textAlign: 'right' }}
            >
              <ControlLabel
                className={classNames(
                  'style-text-lable',
                  isRequired(schema.approver.typeOfApprover.validators) && 'required'
                )}
              >
                {schema.approver.typeOfApprover.label}
              </ControlLabel>
            </Col>
            <Col xs={24} sm={8} md={6} lg={6}>
              <ErrorMessage error={errors[schema.approver.typeOfApprover.name]} />
              <Controller
                key={schema.approver.typeOfApprover.name}
                name={schema.approver.typeOfApprover.name}
                control={control}
                rules={isValidators(schema.approver.typeOfApprover.validators)}
                defaultValue={schema.approver.typeOfApprover.value}
                render={(props) => {
                  return (
                    <RadioGroup
                      value={props.value}
                      onChange={(value) => {
                        props.onChange(value)
                      }}
                      inline
                    >
                      {schema.approver.typeOfApprover?.options?.map((item, index) => {
                        return (
                          <Radio value={item.value} key={index} disabled={isDisabled}>
                            {item.label}
                          </Radio>
                        )
                      })}
                    </RadioGroup>
                  )
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col
              lg={3}
              md={3}
              sm={8}
              xs={8}
              style={{ marginTop: '5px', padding: '8px', textAlign: 'right' }}
            >
              <ControlLabel
                className={classNames(
                  'style-text-lable',
                  isRequired(schema.approver.approveTime.validators) && 'required'
                )}
              >
                {schema.approver.approveTime.label}
              </ControlLabel>
            </Col>
            <Col lg={7} md={8} sm={16} xs={16} style={{ marginTop: '5px' }}>
              <ErrorMessage error={errors[schema.approver.approveTime.name]} />
              <Controller
                key={schema.approver.approveTime.name}
                name={schema.approver.approveTime.name}
                control={control}
                defaultValue={
                  schema.approver.approveTime.value
                    ? moment(schema.approver.approveTime.value, DATE_PICKER_FORMAT).toDate()
                    : null
                }
                rules={isValidators(schema.approver.approveTime.validators)}
                render={(props) => {
                  return (
                    <DatePicker
                      disabled={isDisabled}
                      format="DD/MM/YYYY"
                      locale={LOCAL_DAY_TH}
                      block
                      value={props.value}
                      onChange={(value) => {
                        props.onChange(value)
                      }}
                      disabledDate={(date) => moment().isBefore(date, new Date())}
                    />
                  )
                }}
              />
            </Col>
            <Col lg={2}></Col>
            <Col
              lg={2}
              md={3}
              sm={8}
              xs={8}
              style={{ marginTop: '5px', padding: '8px', textAlign: 'right' }}
            >
              <ControlLabel
              // className={classNames(
              //   'style-text-lable',
              //   isRequired(schema.approver.approverName.validators) && 'required'
              // )}
              >
                {schema.approver.approverName.label}
              </ControlLabel>
            </Col>
            <Col lg={7} md={8} sm={16} xs={16} style={{ marginTop: '0px' }}>
              {/* <ErrorMessage error={errors[schema.approver.approverName.name]} />
              <Input
                disabled={isDisabled}
                name={schema.approver.approverName.name}
                defaultValue={schema.approver.approverName.value || ''}
                inputRef={register(isValidators(schema.approver.approverName.validators))}
              /> */}
              <p style={{ marginTop: '5px', padding: '8px' }}>
                {schema.approver.approverName.prefixName} {schema.approver.approverName.value}
              </p>
            </Col>
          </Row>

          {/* <Row style={{ marginTop: '30px' }}>
            <label style={{ color: '#3DB2A9' }}>{schema.rating.header}</label>
          </Row>

          <Row>
            <Col
              lg={3}
              md={3}
              sm={8}
              xs={8}
              style={{ marginTop: '5px', padding: '8px', textAlign: 'right' }}
            >
              <ControlLabel
                className={classNames(
                  'style-text-lable',
                  isRequired(schema.rating.supportivenessOption.validators) && 'required'
                )}
              >
                {schema.rating.supportivenessOption.label}
              </ControlLabel>
            </Col>
            <Col lg={7} md={8} sm={16} xs={16} style={{ marginTop: '5px' }}>
              <ErrorMessage error={errors[schema.rating.supportivenessOption.name]} />
              <Controller
                name={schema.rating.supportivenessOption.name}
                control={control}
                defaultValue={schema.rating.supportivenessOption.value}
                rules={isValidators(schema.rating.supportivenessOption.validators)}
                render={(props) => {
                  return (
                    <SelectPicker
                      disabled={isDisabled}
                      data={schema.rating.supportivenessOption.options}
                      searchable={false}
                      value={props.value}
                      block
                      onChange={(value) => {
                        props.onChange(value)
                      }}
                    />
                  )
                }}
              />
            </Col>
            <Col lg={2}></Col>
            <Col
              lg={2}
              md={3}
              sm={8}
              xs={8}
              style={{ marginTop: '5px', padding: '8px', textAlign: 'right' }}
            >
              <ControlLabel
                className={classNames(
                  'style-text-lable',
                  isRequired(schema.rating.attractivenessOption.validators) && 'required'
                )}
              >
                {schema.rating.attractivenessOption.label}
              </ControlLabel>
            </Col>
            <Col lg={7} md={8} sm={16} xs={16} style={{ marginTop: '5px' }}>
              <ErrorMessage error={errors[schema.rating.attractivenessOption.name]} />
              <Controller
                name={schema.rating.attractivenessOption.name}
                control={control}
                defaultValue={schema.rating.attractivenessOption.value}
                rules={isValidators(schema.rating.attractivenessOption.validators)}
                render={(props) => {
                  return (
                    <SelectPicker
                      disabled={isDisabled}
                      data={schema.rating.attractivenessOption.options}
                      searchable={false}
                      value={props.value}
                      block
                      onChange={(value) => {
                        props.onChange(value)
                      }}
                    />
                  )
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col lg={3} md={3} sm={8} xs={8} style={{ marginTop: '15px', textAlign: 'right' }}>
              <ControlLabel
                className={classNames(
                  'style-text-lable',
                  isRequired(schema.rating.riskOption.validators) && 'required'
                )}
              >
                {schema.rating.riskOption.label}
              </ControlLabel>
            </Col>
            <Col lg={7} md={8} sm={16} xs={16} style={{ marginTop: 10 }}>
              <ErrorMessage error={errors[schema.rating.riskOption.name]} />
              <Controller
                name={schema.rating.riskOption.name}
                control={control}
                defaultValue={schema.rating.riskOption.value}
                rules={isValidators(schema.rating.riskOption.validators)}
                render={(props) => {
                  return (
                    <SelectPicker
                      disabled={isDisabled}
                      data={schema.rating.riskOption.options}
                      searchable={false}
                      value={props.value}
                      block
                      onChange={(value) => {
                        props.onChange(value)
                      }}
                    />
                  )
                }}
              />
            </Col>
          </Row> */}
        </Grid>
      </Form>
    </>
  )
}
